import { Component, Input, ElementRef, ViewChild } from '@angular/core';

@Component({
	selector: 'app-label-informacion',
	templateUrl: './label-informacion.component.html'
})
export class LabelInformacionComponent {

	@Input("Label") Label: string = "";
	@Input("Dato") Dato: string = "";
	@Input("ClasesCSS") ClasesCSS: string = "";
	@ViewChild("txtArea") txtArea: ElementRef;

	//Tipo textbox puede ser:
	//1 = input
	//2 = textarea
	@Input("TipoTextBox") TipoTextBox: number = 1;

	constructor() { }

	public ngAfterViewInit(): void {
		if (this.txtArea) {
			this.txtArea.nativeElement.style.cssText = 'height:' + this.txtArea.nativeElement.scrollHeight + 'px';
		}
	}
}
